<div class="">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <div class="register-form pt-3">
                    <form [formGroup]="paymentPlanForm">
                        <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" style="margin-bottom: 5px;">
                                <div class="formSection">
                                    <div class="head">
                                        <strong>Payment-Plan Information</strong>
                                    </div>
                                </div>
                                <div class="form-background">
                                    <div class="row" style="padding: 10px;">
                                        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                            <div class="form-group">
                                                <label>Project <span class="formMandatoryInput">*</span></label>
                                                <input type="text" class="project" formControlName="projectName"
                                                    class="form-control project" readonly
                                                    [ngClass]="{'is-invalid': Submitted && f['projectName']?.errors}" />
                                                <div *ngIf="Submitted && f['projectName']?.errors"
                                                    style="color: red; font-size: 12px;">
                                                    Project Name is Reqiured</div>
                                            </div>
                                        </div>
                                        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                            <div class="form-group">
                                                <label> Name <span class="formMandatoryInput">*</span></label>
                                                <input type="text" formControlName="name" class="form-control" min="0"
                                                    placeholder="Name"
                                                    [ngClass]="{'is-invalid': Submitted && f['name']?.errors}">
                                                <div *ngIf="Submitted && f['name']?.errors"
                                                    style="color: red; font-size: 12px;">
                                                    Name Reqiured</div>
                                            </div>
                                        </div>
                                        <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <div class="table-responsive">
                                                <table class="table head">
                                                    <thead>
                                                        <tr>
                                                            <th> Sr. No</th>
                                                            <th> Name</th>
                                                            <th> Amount Percentage</th>
                                                            <th> Due in Days</th>
                                                            <th> Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngFor="let group of paymentPlanArray.controls; let i = index"
                                                        formArrayName="paymentStages">
                                                        <tr [formGroupName]="i">
                                                            <td>{{i+1}}</td>
                                                            <td>
                                                                <input type="text" placeholder="Name" min="0"
                                                                    formControlName="name" class="form-control"
                                                                    [ngClass]="{'is-invalid': Submitted && f['name']?.errors}">
                                                                <div *ngIf="Submitted && f['Name']?.errors"
                                                                    style="color: red; font-size: 12px;">
                                                                    Name Reqiured</div>
                                                            </td>
                                                            <td>
                                                                <input type="number" placeholder="Amount/Percentage"
                                                                    formControlName="amountPercentage" min="0"
                                                                    [max]="100" class="form-control"
                                                                    [ngClass]="{'is-invalid': Submitted && f['amountPercentage']?.errors}">
                                                                <div *ngIf="Submitted && f['amountPercentage']?.errors"
                                                                    style="color: red; font-size: 12px;">
                                                                    Amount Percentage Reqiured</div>
                                                            </td>
                                                            <td>
                                                                <input type="number" placeholder="Due in Days"
                                                                    formControlName="dueInDays"
                                                                    class="form-control small-input" min="0"
                                                                    [ngClass]="{'is-invalid': Submitted && f['dueInDays']?.errors}">
                                                                <div *ngIf="Submitted && f['dueInDays']?.errors"
                                                                    style="color: red; font-size: 12px;">
                                                                    DueInDays Reqiured</div>
                                                            </td>
                                                            <td>
                                                                <div>

                                                                    <!-- Show the add icon only on the last row -->
                                                                    <img *ngIf="i === paymentPlanArray.controls.length - 1"
                                                                        src="{{ addArrayIcon }}"
                                                                        (click)="addAddressGroup()" />
                                                                    &nbsp;

                                                                    <!-- Show the delete icon on all rows except the first one if there are multiple rows -->
                                                                    <img *ngIf="paymentPlanArray.controls.length > 1 && i > 0"
                                                                        src="{{ deleteArrayIcon }}"
                                                                        (click)="removeaddField(i)" />

                                                                    <!-- Show only delete icon on the first row when there are multiple rows -->
                                                                    <img *ngIf="i === 0 && paymentPlanArray.controls.length > 1"
                                                                        src="{{ deleteArrayIcon }}"
                                                                        (click)="removeaddField(i)" />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pad-wrap col-sm-12">
                            <div class="invoice-button d-flex">
                                <div class="col-md-8 col-sm-12">
                                    <h6 style="float:left;"><strong>Note : </strong>Sum of Amount Percentage should be
                                        100.</h6>
                                </div>
                                <div class="col-md-4 col-sm-12">
                                    <span style="float: right;"><button type="submit"
                                            class="btn btn-success  cancel mr-2" [disabled]="paymentPlanForm.invalid"
                                            (click)="onSubmit()">Submit</button>
                                        <button type="button" class="btn btn-danger  cancel"
                                            (click)="changeModalState(false)">Cancel</button>
                                    </span>
                                </div>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</div>




<!-- Document Pic upload modal ends here. -->